<ion-content class="app-content login-content">
    <div class="login-form">
        <form (submit)="login (false);">
            <div class="login-row"><input type="text" name="name" [(ngModel)]="name" placeholder="Username"></div>
            <div class="login-row"><input type="password" name="password" [(ngModel)]="password" placeholder="Password">
            </div>
            <div class="login-row"><button>Log in</button></div>
            <div class="login-row login-error" [innerHTML]="error"></div>
        </form>
    </div>
    <div style="position: absolute; bottom: 0px; right: 0px; width: 50px; height: 50px;"
        (click)="testPopup()">
    </div>
</ion-content>